import React from "react";
import banner1 from "../assets/images/banner_1.jpg";
import testimonialimg from "../assets/images/university.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../assets/css/style.css"

const university = () => {
    return (
        <div>
            <div class="banner-one">
                <div class="container">
                    <div class="row d-flex align-items-center">

                        <div class="col-md-6 col-sm-12 po-r">
                            <div class="banner-content">
                                <h4 class="display-6 b-title">Empowering Universities
                                    to Reach Students Worldwide</h4>
                                <div class="b-description">
                                    <p >With GuideUni, universities gain a powerful platform designed to make international student recruitment seamless and efficient. Our free software solution connects you with a global network of certified recruiters, enabling you to attract diverse student talent from around the world. Join us to simplify your recruitment process, improve communication, and expand your institution’s visibility.</p>
                                </div>


                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">


                        </div>
                    </div>
                </div>


            </div>
            <div class="banner-bottom">
                <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 text-center banner-bottom-text">
                                Why Choose GuideUni?
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sectio-1">
                <ul>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Free Access to a Global Network
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>Enjoy a comprehensive, no-cost solution tailored to your recruitment needs. GuideUni provides access to thousands of pre-vetted recruiters, allowing you to build partnerships without additional costs.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Enhanced Admissions Management
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>From application tracking to real-time status updates, GuideUni makes managing admissions simple. Access detailed insights into each applicant’s journey, ensuring you can make informed, timely decisions.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Increase Global Visibility
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>Expand your reach by promoting your institution to potential students worldwide. GuideUni enables you to showcase your programs, campus life, and unique offerings, making it easier to stand out in a competitive market.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Safe and Compliant Data Handling
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>Data security is our priority. GuideUni’s platform is built to handle sensitive student information securely, ensuring compliance with global data protection standards, so you can recruit confidently.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="features-section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-sm-12" ></div>
                        <div class="col-md-6 col-sm-12 features-section-text" >
                            <h4>Features</h4>
                            <h5>Recruiter Network Access</h5>
                            <p>Connect with certified, professional recruiters specializing in international placements. GuideUni’s network gives you the ability to handpick recruiters that align with your institution’s mission and goals.</p>
                            <h5>Centralized Application Management</h5>
                            <p>Use a single dashboard to manage applications from initial interest to enrollment. Track each step of the admissions process and communicate directly with recruiters to streamline decision-making.</p>
                            <h5>Real-Time Reporting and Insights</h5>
                            <p>Get in-depth analytics to understand recruitment trends, application success rates, and recruiter performance. Use data-driven insights to continuously optimize your recruitment strategies.</p>
                            <h5>Document Management</h5>
                            <p>Handle all required documents in one secure location. GuideUni’s platform enables easy upload, review, and storage of documents, ensuring a hassle-free process for both recruiters and applicants.</p>
                            <h5>Automated Communication Tools</h5>
                            <p>Simplify engagement with recruiters and applicants through automated messaging, updates, and notifications. Keep everyone informed and reduce response times without additional administrative work.</p>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default university;